// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ErrorPage_wrap__2UBl1","title":"ErrorPage_title__1RNQM","description":"ErrorPage_description__3xXSY","button":"ErrorPage_button__3V1Om"};